export function formatSupportUnreadBadgeCount(count: number): string {
  return count > 9 ? '9+' : String(count);
}

export function supportUnreadAccessibilitySuffix(count: number): string {
  return `${count} respuesta${count > 1 ? 's' : ''} sin leer del equipo`;
}

export function withSupportUnreadAccessibilityLabel(baseLabel: string, count: number): string {
  if (count <= 0) return baseLabel;
  return `${baseLabel}, ${supportUnreadAccessibilitySuffix(count)}`;
}
